//Quiz main page
class QuizNewComponent extends HTMLElement {
	constructor() {
		super();
		//store dog and your information
		this.dogInformation = {
			currentStep: 0,
			totalStep: 6,
			lastCompletedStep: 0,
			isDogHealthy: false,
			progress: 0,
			isQualifyForQuizProduct: false,
			dogInfo: {
				name: "",
				gender: "",
				ageYrs: "",
				ageMonths: "",
				weight: "1-10 lbs",
				health: "",
				activity: "",
				healthIssue: false,
				multiSelect: [],
				dogBreed: "",
			},
			yourInfo: {
				yourName: "",
				email: "",
			},
		};

		//dog diet information according to their health
		this.dogDiet = {
			noHealthIssue: [
				"Gentle diet for a sensitive stomach",
				"Gentle diet for a puppy",
				"Anti-inflammatory",
				"Lean meat",
				"Light and low fat diet",
				"Vegetarian",
				"Improve body and skin dryness",
				"Hearty meal",
				"Hypoallergenic",
				"Picky eater",
			],
			healthIssue: [
				"Sensitive stomach",
				"Liver support",
				"Seizures",
				"Pancreatitis",
				"Cushings",
				"Environmental skin allergies",
				"Anxiety",
				"Obesity",
				"Cancer remission",
				"Weight gain",
				"Cancer treatment",
				"Diabetes",
				"Inflammatory Bowel Disease",
				"Food allergies",
				"Kidney support",
				"Arthritis and hind leg weakness",
				"Not listed here",
			],
		};

		//quiz wrapper
		this.quizStepElm = this.querySelectorAll(".dog_quizWrapper");

		//dog weight
		this.dogWeightElm = this.querySelector(
			'variant-selects-box select[name*="eight"]'
		);

		//multistep
		this.multiStepContainer = this.querySelector(
			'[step-name="multiField"]'
		);

		//get dog information and set in local storage
		this._getDogInfomation();

		//dispatch all the events
		this._dispatchEvent();

		//activate the last step when we reload the page
		this._activateStep();

		//custom events
		this.lastQuizStep = new CustomEvent("lastQuizStep", {
			bubbles: true,
			detail: {
				text: () => "last form step",
			},
		});
	}
	/**
	 * pure functions
	 */
	// live click method
	_liveClickMethod(selector, event, callback, context) {
		// helper for enabling IE 8 event bindings
		function addEvent(el, type, handler) {
			if (el.attachEvent) el.attachEvent("on" + type, handler);
			else el.addEventListener(type, handler);
		}
		// matches polyfill
		this &&
			this.Element &&
			(function (ElementPrototype) {
				ElementPrototype.matches =
					ElementPrototype.matches ||
					ElementPrototype.matchesSelector ||
					ElementPrototype.webkitMatchesSelector ||
					ElementPrototype.msMatchesSelector ||
					function (selector) {
						var node = this,
							nodes = (
								node.parentNode || node.document
							).querySelectorAll(selector),
							i = -1;
						while (nodes[++i] && nodes[i] != node);
						return !!nodes[i];
					};
			})(Element.prototype);
		// live binding helper using matchesSelector
		function _liveClickMethod(selector, event, callback, context) {
			addEvent(context || document, event, function (e) {
				var found,
					el = e.target || e.srcElement;
				while (
					el &&
					el.matches &&
					el !== context &&
					!(found = el.matches(selector))
				)
					el = el.parentElement;
				if (found) callback.call(el, e);
			});
		}
		_liveClickMethod(selector, event, callback, context);
	}
	//remove class
	removeClass(selector, cls) {
		var el = document.querySelectorAll(selector);
		if (el.length > 0) {
			el.forEach(function (item) {
				item.classList.contains(cls) && item.classList.remove(cls);
			});
		}
	}
	//waitFor Datalayer
	onDataHelperLoad(callback) {
		var intervalId = setInterval(function () {
			if (typeof window.dataLayer != "undefined") {
				clearInterval(intervalId);
				callback();
			}
		}, 30);
		setTimeout(function () {
			clearInterval(intervalId);
		}, 15000);
	}
	//ga events
	trackGAEvent(eventCategory, eventAction, eventLabel) {
		if ("ga" in window && "getAll" in window.ga) {
			ga.getAll()[0].send("event", {
				eventCategory: eventCategory,
				eventAction: eventAction,
				eventLabel: eventLabel,
			});
		}
	}

	/**
	 * functions used in quiz container
	 */
	/**
	 * -----------------------------------------
	 * on page load update the quiz form
	 */
	//update dog names
	updateDogName(value) {
		var dogNameLabel = this.querySelectorAll('[data-name="dog-name"]');
		if (dogNameLabel.length > 0) {
			dogNameLabel.forEach(function (label) {
				if (value.length > 0) {
					label.innerHTML = value;
				} else {
					label.innerHTML = "[dog’s name]";
				}
			});
		}
	}
	//autofill step if already step complete
	autofillCompletedStep() {
		var data = this.dogInformation;
		if (data.currentStep > 1) {
			var dogInfoField = data.dogInfo;

			//dog info field
			var inputField = this.querySelectorAll(
				'[step-name="dogInfo"] input'
			);
			if (inputField.length > 0) {
				//loop input field
				inputField.forEach(function (input) {
					var type = input.type,
						name = input.name;
					switch (true) {
						case type == "text":
							input.value = dogInfoField[name];
							break;
						case type == "radio" &&
							input.value == dogInfoField[name]:
							input.click();
							input.parentElement.classList.add(
								"selected_option"
							);
							break;
						case type == "number":
							input.value = dogInfoField[name];
							break;
					}
				});
			}
			var inputFieldselect = this.querySelectorAll(
				'[step-name="dogInfoselect"] select'
			);
			if (inputFieldselect.length > 0) {
				//loop input field
				inputFieldselect.forEach(function (input) {
					var type = input.type,
						name = input.name;
					switch (true) {
						case type == "select-one":
							input.value = dogInfoField[name];
							break;
					}
				});
			}
			//update your information
			var yourInformation = data.yourInfo;
			var yourInputField = this.querySelectorAll(
				'[step-name="yourInfo"] input'
			);
			if (yourInputField.length > 0) {
				//loop input field
				yourInputField.forEach(function (input) {
					var type = input.type,
						name = input.name;
					switch (true) {
						case type == "text" || type == "email":
							input.value = yourInformation[name];
							break;
					}
				});
			}
		}
	}
	//get and set the dog information in dogInformation object
	_getDogInfomation() {
		var localDogInfo = localStorage.getItem("dogInformation");
		if (localDogInfo) {
			Object.assign(this.dogInformation, JSON.parse(localDogInfo));
			//filled completed step
			this.autofillCompletedStep();
			//update dog names
			this.updateDogName(this.dogInformation.dogInfo.name);
		} else {
			localStorage.setItem(
				"dogInformation",
				JSON.stringify(this.dogInformation)
			);
		}
	}
	//active current step
	_activateStep() {
		var step = this.dogInformation.currentStep;
		if (step > -1) {
			var currentStepWrapper = this.querySelectorAll(".dog_quizWrapper");
			if (currentStepWrapper.length > 0 && currentStepWrapper[step]) {
				var alreadyActive = this.querySelector(".active_questionStep");
				alreadyActive &&
					alreadyActive.classList.remove("active_questionStep");
				currentStepWrapper[step].classList.add("active_questionStep");
			}

			//insert section
			var multiSelectOptions = this.buildMultiSelectOption();
			if (this.querySelector(".quiz_multiSelects")) {
				this.querySelector(".quiz_multiSelects").innerHTML =
					multiSelectOptions;
			}
			var headerText = this.buildMultiHeader();
			if (
				this.querySelector('[step-name="multiField"] .quiz_headingBox')
			) {
				this.querySelector(
					'[step-name="multiField"] .quiz_headingBox'
				).innerHTML = headerText;
			}

			//active multistep
			if (
				this.multiStepContainer &&
				this.dogInformation.dogInfo.isDogHealthy == true
			) {
				this.multiStepContainer.classList.add("no_healhIssueAppear");
			}
		}
	}

	/**
	 * -----------------------------------------
	 * generate multiSelect option form
	 * use - step === 3 or onpageload
	 */
	buildMultiSelectOption() {
		var html = "";
		var alreadySelected = this.dogInformation.dogInfo.multiSelect;

		//check dog healthy or not
		if (this.dogInformation.isDogHealthy == false) {
			this.dogDiet.healthIssue.forEach(function (diet) {
				var cls = "";
				if (alreadySelected.includes(diet)) {
					cls = 'class="selected_option"';
				}
				html += `<li data-value="${diet}" ${cls}>${diet}</li>`;
			});
			document.getElementById("health-issue-list-yes").style.display =
				"block";
			document.getElementById("health-issue-list-no").style.display =
				"none";
			document
				.getElementById("quiz_multiSelects")
				.classList.add("health_issues_yes");
			document
				.getElementById("quiz_multiSelects")
				.classList.remove("health_issues_no");
		} else {
			this.dogDiet.noHealthIssue.forEach(function (diet) {
				var cls = "";
				if (alreadySelected.includes(diet)) {
					cls = 'class="selected_option"';
				}
				html += `<li data-value="${diet}" ${cls}>${diet}</li>`;
			});
			document.getElementById("health-issue-list-no").style.display =
				"block";
			document.getElementById("health-issue-list-yes").style.display =
				"none";
			document
				.getElementById("quiz_multiSelects")
				.classList.add("health_issues_no");
			document
				.getElementById("quiz_multiSelects")
				.classList.remove("health_issues_yes");
		}
		return html;
	}

	//build multiselect heading
	buildMultiHeader() {
		var dogHealth = this.dogInformation.isDogHealthy;
		var dogName = this.dogInformation.dogInfo.name;
		var html = "";
		if (!dogHealth) {
			html +=
				'<h1 class="quiz_stepHeading">Please tell us more about <span data-name="dog-name">' +
				dogName +
				"</span>’s health issues</h1>" +
				'<p class="subHeading">Multi select (select as many conditions as apply)</p>';
		} else {
			html +=
				'<h1 class="quiz_stepHeading">HOW CAN WE BETTER SUPPORT<span data-name="dog-name"> ' +
				dogName.toUpperCase() +
				" </span>THROUGH FOOD THERAPY?</h1>" +
				'<p class="subHeading">Multi select (select as many indications as you see fit)</p>';
		}
		return html;
	}

	/**
	 * -----------------------------------------
	 * form validation step
	 */
	//email validation
	ValidateEmail(inputText) {
		var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
		if (mailformat.test(inputText)) {
			return true;
		} else {
			return false;
		}
	}
	//trigger error
	triggerErrorMsg(names, formData) {
		var _this = this;
		names.forEach(function (name) {
			var inputField = _this.querySelector(
				'.dog_quizWrapper form [name="' + name + '"]'
			);
			if (inputField) {
				var errorField = inputField.closest(
					".quiz_optionField,.quiz_inputField, .quiz_ageColumn"
				);
				if (errorField) {
					errorField = errorField.querySelector(".input_error");
				}

				//input value
				var isFill = formData.get(inputField.name);

				if (errorField) {
					switch (inputField.type) {
						case "text":
							if (inputField.value == "") {
								errorField.classList.add("showError");
							} else {
								errorField.classList.contains("showError") &&
									errorField.classList.remove("showError");
							}
							break;
						case "email":
							if (!_this.ValidateEmail(inputField.value)) {
								errorField.classList.add("showError");
							} else {
								errorField.classList.contains("showError") &&
									errorField.classList.remove("showError");
							}
							break;
						case "radio":
							if (isFill == null) {
								errorField.classList.add("showError");
							} else {
								errorField.classList.contains("showError") &&
									errorField.classList.remove("showError");
							}
							break;
						case "number":
							if (inputField.value == null) {
								errorField.classList.add("showError");
							} else {
								errorField.classList.contains("showError") &&
									errorField.classList.remove("showError");
							}
							break;
						case "select-one":
							if (inputField.value == "") {
								errorField.classList.add("showError");
							} else {
								errorField.classList.contains("showError") &&
									errorField.classList.remove("showError");
							}
							break;
					}
				}
			}
		});
	}
	//multiSelect
	updateMultipleSelect() {
		this.dogInformation.dogInfo.multiSelect = [];
		var _this = this;
		var selectedOptions = this.querySelectorAll(
			".quiz_multiSelects li.selected_option"
		);
		selectedOptions.forEach(function (option) {
			_this.dogInformation.dogInfo.multiSelect.push(option.innerText);
		});
	}
	//main form validation step
	formValidation(form, step, stepWrapper) {
		var formData = new FormData(form),
			isStepValid = true;

		//step type
		var stepType = stepWrapper.getAttribute("step-name");

		//check step conditions
		if (step === 1) {
			//form validation
			var dogName = formData.get("name"),
				gender = formData.get("gender"),
				ageYrs = formData.get("ageYrs"),
				ageMonths = formData.get("ageMonths"),
				dogBreed = formData.get("dogBreed");

			//trigger error msg
			this.triggerErrorMsg(
				["name", "gender", "ageYrs", "ageMonths", "dogBreed"],
				formData
			);

			//check field
			if (!dogName || !gender || !ageYrs || !ageMonths || !dogBreed) {
				isStepValid = false;
			}
		} else if (step === 2) {
			var dogWeight = formData.get("weight"),
				health = formData.get("health");

			//trigger error msg
			this.triggerErrorMsg(["health"], formData);

			if (health == null) {
				isStepValid = false;
			}
		} else if (step === 3) {
			var activity = formData.get("activity"),
				healthIssue = formData.get("healthIssue");

			//trigger error msg
			this.triggerErrorMsg(["activity", "healthIssue"], formData);

			//dog healthy or not
			if (healthIssue == "no") {
				this.dogInformation.isDogHealthy = true;
				this.multiStepContainer &&
					this.multiStepContainer.classList.add(
						"no_healhIssueAppear"
					);
				document.getElementById("health-issue-list-no").style.display =
					"block";
				document.getElementById("health-issue-list-yes").style.display =
					"none";
				document
					.getElementById("quiz_multiSelects")
					.classList.add("health_issues_no");
				document
					.getElementById("quiz_multiSelects")
					.classList.remove("health_issues_yes");
			} else {
				this.dogInformation.isDogHealthy = false;
				this.multiStepContainer &&
					this.multiStepContainer.classList.contains(
						"no_healhIssueAppear"
					) &&
					this.multiStepContainer.classList.remove(
						"no_healhIssueAppear"
					);
				document.getElementById("health-issue-list-yes").style.display =
					"block";
				document.getElementById("health-issue-list-no").style.display =
					"none";
				document
					.getElementById("quiz_multiSelects")
					.classList.add("health_issues_yes");
				document
					.getElementById("quiz_multiSelects")
					.classList.remove("health_issues_no");
			}

			if (activity == "" || healthIssue == null) {
				isStepValid = false;
			}

			//insert section
			var multiSelectOptions = this.buildMultiSelectOption();
			if (this.querySelector(".quiz_multiSelects")) {
				this.querySelector(".quiz_multiSelects").innerHTML =
					multiSelectOptions;
			}
			var headerText = this.buildMultiHeader();
			if (
				this.querySelector('[step-name="multiField"] .quiz_headingBox')
			) {
				this.querySelector(
					'[step-name="multiField"] .quiz_headingBox'
				).innerHTML = headerText;
			}
		} else if (step === 4 && stepType == "multiField") {
			//multiField step
			this.updateMultipleSelect();

			var selectedOptions = this.querySelectorAll(
				".quiz_multiSelects li.selected_option"
			);
			var multiSelectError = this.querySelector(
				'[step-name="multiField"] .quiz_stepFormMain .input_error'
			);
			if (
				selectedOptions.length < 1 &&
				!this.dogInformation.isDogHealthy
			) {
				isStepValid = false;

				multiSelectError && multiSelectError.classList.add("showError");
			} else {
				multiSelectError &&
					multiSelectError.classList.contains("showError") &&
					multiSelectError.classList.remove("showError");
			}
		} else if (stepType == "yourInfo") {
			//your information
			var email = formData.get("email"),
				yourName = formData.get("yourName");
			this.triggerErrorMsg(["email", "yourName"], formData);
			if (!this.ValidateEmail(email) || !yourName) {
				isStepValid = false;
			}
		}

		//assign form data to dog information object
		if (stepType == "dogInfo") {
			let obj = {};
			for (let [key, val] of formData) {
				obj[key] = val;
			}

			if (this.dogWeightElm) {
				this.dogInformation.dogInfo.weight =
					this.dogWeightElm && this.dogWeightElm.value;
			}

			Object.assign(this.dogInformation.dogInfo, obj);
		} else if (stepType == "yourInfo") {
			let obj = {};
			for (let [key, val] of formData) {
				obj[key] = val;
			}
			Object.assign(this.dogInformation.yourInfo, obj);
		}

		if (isStepValid) {
			this.dogInformation.lastCompletedStep =
				this.dogInformation.currentStep;
			//update dog information in localStorage
			localStorage.setItem(
				"dogInformation",
				JSON.stringify(this.dogInformation)
			);
		}

		return isStepValid;
	}
	// show and hide step
	showNextSteps(isBack) {
		//quiz row
		var quizRow = this.quizStepElm[this.dogInformation.currentStep + 1];
		if (isBack) {
			quizRow = this.quizStepElm[this.dogInformation.currentStep - 1];
		}

		//active new step
		if (this.quizStepElm.length > 0 && quizRow) {
			if (isBack) {
				//step increament
				this.dogInformation.currentStep--;
			} else {
				//step increament
				this.dogInformation.currentStep++;
			}

			//remove class
			this.removeClass(".dog_quizWrapper", "active_questionStep");

			this.quizStepElm[this.dogInformation.currentStep].classList.add(
				"active_questionStep"
			);

			if (
				this.dogInformation.lastCompletedStep <=
					this.dogInformation.currentStep &&
				!isBack
			) {
				if (this.dogInformation.currentStep > 4) {
					this.dogInformation.isQualifyForQuizProduct = true;
				} else {
					this.dogInformation.isQualifyForQuizProduct = false;
				}

				//update dog information in localStorage
				localStorage.setItem(
					"dogInformation",
					JSON.stringify(this.dogInformation)
				);
			}

			//update last step
			if (this.dogInformation.currentStep > 5) {
				//dispact last step
				window.dispatchEvent(this.lastQuizStep);
			}
		}
	}
	// Change step
	_updateStep(buttonElm, isBack) {
		//step form
		var stepWrapper = buttonElm.closest(".dog_quizWrapper");
		var stepForm = stepWrapper.querySelector("form");

		if (!stepForm) {
			//if step form not available
			this.showNextSteps(isBack);

			//ga
			if (this.dogInformation.currentStep == 1) {
				var label = "Quiz Step Started";
				this.trackGAEvent("Quiz_Form_Step", "Step", label);

				//step start
				this.onDataHelperLoad(function () {
					dataLayer.push({
						event: "Quiz Form Step",
						stepCount: "Quiz Start",
						stepInfo: {},
					});
				});
			}

			//Scroll to top
			//window.scrollTo(0, 0)
			this.scrollToQuizStepHeading();
		} else if (
			!isBack &&
			this.formValidation(
				stepForm,
				this.dogInformation.currentStep,
				stepWrapper
			)
		) {
			//form validation
			this.showNextSteps();

			//datalayer events
			var _this = this;
			this.onDataHelperLoad(function () {
				dataLayer.push({
					event: "Quiz Form Step",
					stepCount: _this.dogInformation.currentStep - 1,
					stepInfo: _this.dogInformation,
				});
			});

			//ga
			var label =
				"Step Completed " + (_this.dogInformation.currentStep - 1);
			this.trackGAEvent("Quiz_Form_Step", "Step", label);

			// Scroll to top
			// window.scrollTo(0, 0)
			this.scrollToQuizStepHeading();
		} else if (isBack) {
			//previous step
			this.showNextSteps(isBack);

			//Scroll to top
			//window.scrollTo(0, 0)
			this.scrollToQuizStepHeading();
		}
	}
	scrollToQuizStepHeading() {
		$("html, body").scrollTop($(".quiz_stepHeading").offset().top);
	}

	//events handlers
	_dispatchEvent() {
		var _this = this;

		//click on next step button
		this._liveClickMethod(
			".quiz_nextStepButton button",
			"click",
			function (e) {
				_this._updateStep(this);
			}
		);

		//click on back button
		this._liveClickMethod(
			".dog_quizWrapper .quiz_prevStepButton",
			"click",
			function () {
				_this._updateStep(this, true);
			}
		);
		//click on weight option_row
		this._liveClickMethod(
			'.quiz_inputField variant-selects .select__select[name*="eight"]',
			"change",
			function () {
				var info = localStorage.getItem("dogInformation");
				if (info) {
					info = JSON.parse(info);
					info.dogInfo.weight = this.value;
					//update dog information in localStorage
					localStorage.setItem(
						"dogInformation",
						JSON.stringify(info)
					);
				}
			}
		);
		//click on radio options
		this._liveClickMethod(
			".dog_quizWrapper .option_row input",
			"click",
			function () {
				var parentElement = this.closest(".option_row");
				if (parentElement) {
					var selectedElm =
						parentElement.querySelector(".selected_option");
					selectedElm &&
						selectedElm.classList.remove("selected_option");

					//add active in current option
					this.parentElement.classList.add("selected_option");
				}
			}
		);

		//click on multiSelect
		this._liveClickMethod(".quiz_multiSelects li", "click", function () {
			this.classList.toggle("selected_option");
		});

		//dog name Change
		this._liveClickMethod(
			".dog_quizWrapper #dog-name",
			"input",
			function () {
				var value = this.value;
				_this.updateDogName(value);
			}
		);

		//age value
		this._liveClickMethod(".dog_quizWrapper #years", "input", function () {
			if (this.value > 20 && this.value.length == 2) {
				this.value = this.value.slice(0, 1);
			} else if (this.value.length > 2) {
				this.value = this.value.slice(0, 2);
			}
		});
		this._liveClickMethod(".dog_quizWrapper #month", "input", function () {
			if (this.value > 12 && this.value.length == 2) {
				this.value = this.value.slice(0, 1);
			} else if (this.value.length > 2) {
				this.value = this.value.slice(0, 2);
			}
		});
	}
}
window.customElements.define("new-quiz-component", QuizNewComponent);

//Quiz last step
class QuizLastStep extends HTMLElement {
	constructor() {
		super();
		//diet options
		this.dietOptions = {
			healthIssue: {
				wood: ["Sensitive stomach", "Liver support", "Seizures"],
				fire: [
					"Pancreatitis",
					"Cushings",
					"Environmental skin allergies",
					"Anxiety",
				],
				earth: ["Obesity", "Cancer remission"],
				metal: ["Weight gain", "Cancer treatment", "Diabetes"],
				water: [
					"Inflammatory Bowel Disease",
					"Food allergies",
					"Kidney support",
					"Arthritis and hind leg weakness",
				],
			},
			healthy: {
				wood: [
					"Gentle diet for a sensitive stomach",
					"Gentle diet for a puppy",
				],
				fire: ["Anti-inflammatory", "Lean meat"],
				earth: ["Light and low fat diet", "Vegetarian"],
				metal: ["Improve body and skin dryness", "Hearty meal"],
				water: ["Hypoallergenic", "Picky eaters"],
			},
			totalDiet: ["wood", "fire", "earth", "metal", "water"],
			dietData: {
				wood: {
					image: "https://cdn.shopify.com/s/files/1/0550/7543/8658/files/wood-diet.svg",
					icon: "https://cdn.shopify.com/s/files/1/0550/7543/8658/files/wood-icon.svg",
					items: [
						"Chicken",
						"Chicken Eggs",
						"Brown Rice",
						"Chinese Eggplant",
						"Carrots",
						"Broccoli",
					],
				},
				fire: {
					image: "https://cdn.shopify.com/s/files/1/0550/7543/8658/files/fire-diet.svg",
					icon: "https://cdn.shopify.com/s/files/1/0550/7543/8658/files/fire-icon.svg",
					items: [
						"Turkey",
						"Carrots",
						"Millet",
						"Edamame",
						"Broccoli",
					],
				},
				earth: {
					image: "https://cdn.shopify.com/s/files/1/0550/7543/8658/files/earth-diet.svg",
					icon: "https://cdn.shopify.com/s/files/1/0550/7543/8658/files/Vector_2_ba4c03af-4742-44cd-8c5e-4aa222823784.png?v=1671020951",
					items: [
						"Egg",
						"Sweet Potato",
						"Green Peas",
						"Tofu",
						"Spinach",
						"Mushroom",
					],
				},
				metal: {
					image: "https://cdn.shopify.com/s/files/1/0550/7543/8658/files/metal-diet.svg",
					icon: "https://cdn.shopify.com/s/files/1/0550/7543/8658/files/metal-icon.svg",
					items: [
						"Beef",
						"Kale",
						"Bok Choy",
						"White Potato",
						"Carrots",
					],
				},
				water: {
					image: "https://cdn.shopify.com/s/files/1/0550/7543/8658/files/water-diet.svg",
					icon: "https://cdn.shopify.com/s/files/1/0550/7543/8658/files/Vector_4.png?v=1671020967",
					items: [
						"Pork",
						"Peas",
						"Watercress",
						"Barley",
						"Sweet Potato",
					],
				},
				bag: {
					image: "https://cdn.shopify.com/s/files/1/0550/7543/8658/files/bag.png?v=1675187833",
					title: "Keep Fresh Storage Bag",
				},
			},
		};

		//store dog and your information
		var localDogInfo = localStorage.getItem("dogInformation");
		this.dogInformation = localDogInfo && JSON.parse(localDogInfo);

		//variant options
		this.variants = this.querySelectorAll(
			".product-container .product-left-content .hero-section .check-box > input"
		);

		//all step qualifying
		this.filterDietOptions();

		//dispatch eventsTarget
		this.dispatchEventHandler();
	}
	/**
	 * pure functions
	 */
	// live click method
	_liveClickMethod(selector, event, callback, context) {
		// helper for enabling IE 8 event bindings
		function addEvent(el, type, handler) {
			if (el.attachEvent) el.attachEvent("on" + type, handler);
			else el.addEventListener(type, handler);
		}
		// matches polyfill
		this &&
			this.Element &&
			(function (ElementPrototype) {
				ElementPrototype.matches =
					ElementPrototype.matches ||
					ElementPrototype.matchesSelector ||
					ElementPrototype.webkitMatchesSelector ||
					ElementPrototype.msMatchesSelector ||
					function (selector) {
						var node = this,
							nodes = (
								node.parentNode || node.document
							).querySelectorAll(selector),
							i = -1;
						while (nodes[++i] && nodes[i] != node);
						return !!nodes[i];
					};
			})(Element.prototype);
		// live binding helper using matchesSelector
		function _liveClickMethod(selector, event, callback, context) {
			addEvent(context || document, event, function (e) {
				var found,
					el = e.target || e.srcElement;
				while (
					el &&
					el.matches &&
					el !== context &&
					!(found = el.matches(selector))
				)
					el = el.parentElement;
				if (found) callback.call(el, e);
			});
		}
		_liveClickMethod(selector, event, callback, context);
	}
	//remove class
	removeClass(selector, cls) {
		var el = document.querySelectorAll(selector);
		if (el.length > 0) {
			el.forEach(function (item) {
				item.classList.contains(cls) && item.classList.remove(cls);
			});
		}
	}
	//add Class
	addClass(selector, cls) {
		var el = document.querySelector(selector);
		if (el) {
			el.classList.add(cls);
		}
	}

	/**
	 * variant diet code
	 */
	//build diet card
	buildDietVariant(diet, type, index) {
		var checkedDiet = "";
		var activeCls = "";
		if (type == "recommend") {
			checkedDiet = "checked";
		}

		//active diet variant
		if (index == 0) {
			activeCls = "active_dietVariant";

			//active diet detail
			var activeDiet = document.querySelector(
				"#product-right-content .product-diet-row.product-diet-active"
			);
			var newActiveDiet = document.querySelector(
				`#product-right-content .product-diet-row[data-type='${diet}']`
			);
			activeDiet && activeDiet.classList.remove("product-diet-active");
			newActiveDiet && newActiveDiet.classList.add("product-diet-active");
		}

		//diet data change
		var data = this.dietOptions.dietData[`${diet}`];
		var dietList = "";
		if (data) {
			data.items.forEach(function (item) {
				dietList += `<li>${item}<span style="display: none;" class="diet_listMobile">/</span></li>`;
			});

			var html = `
      <div class="diet-box-1 variety-box ${activeCls}" diet-type="${diet}">
      <div id="tab-fire-recommendation-quiz" class="recommendation" >Recommended</div>
          <label class="check-box" for="${diet}-diet">
              <input type="checkbox" id="${diet}-diet" name="${diet}" ${checkedDiet} isrecommend="${type}">
              <div class="diet-img">
                  <img src="${data.image}" alt="${diet}">
              </div>
          </label>
          <div class="dite-opt">
              <h2>${diet} Diet</h2>
               <ul class="diet">${dietList}</ul>
              <div class="logo"><img src="${data.icon}" alt=""></div>
          </div>
      </div>`;
		} else {
			return "";
		}

		return html;
	}
	//recommended diet
	getVariantSection(diets, type) {
		var html = "",
			_this = this;
		if (type == "recommend") {
			diets.forEach(function (diet, i) {
				html += _this.buildDietVariant(diet, "recommend", i);
			});
		} else {
			diets.forEach(function (diet) {
				html += _this.buildDietVariant(diet);
			});
		}

		return html;
	}
	//update diet
	udpateDietsVariant(diets) {
		var otherVariants = this.dietOptions.totalDiet.filter((i) => {
			//if diet includes i(diet name) or if diet length 0 and i is not contains "wood"
			return (
				(diets.length == 0 && i != "wood") ||
				(!diets.includes(i) && diets.length > 0)
			);
		});

		//recommended diet
		this.recommendEl = this.querySelector(".bm-selected-diet");
		if (this.recommendEl) {
			if (diets.length > 0) {
				var html = this.getVariantSection(diets, "recommend");
				this.recommendEl.innerHTML = html;
			} else {
				diets = ["wood"];
				var html = this.getVariantSection(diets, "recommend");
				this.recommendEl.innerHTML = html;
			}
		}

		//other variant section
		this.otherDiet = this.querySelector(".bm-all-diet");
		if (this.otherDiet) {
			var html = "";
			if (otherVariants.length > 0) {
				html = this.getVariantSection(otherVariants);
			} else {
				html = "";
			}

			this.otherDiet.innerHTML = html;
		}

		//variant select options
		this.variants = this.querySelectorAll(
			".product-container .product-left-content .hero-section .check-box > input"
		);
	}
	//variant selection
	variantSelectionBox() {
		var selectedVariant = {
			"Recommended Variant": [],
			"Other Variety": [],
		};

		if (this.variants.length > 0) {
			this.variants.forEach(function (variant) {
				if (variant.checked) {
					if (variant.getAttribute("isrecommend") == "recommend") {
						selectedVariant["Recommended Variant"].push(
							variant.name
						);
					} else {
						selectedVariant["Other Variety"].push(variant.name);
					}
				}
			});
		}

		return selectedVariant;
	}
	//update properties
	updateProperties(quizData) {
		if (quizData.yourInfo.yourName) {
			var propertyElm = document.querySelector(".product_properties");
			var html = "";

			var variantInfo = this.variantSelectionBox();

			//property
			var propertyList = {
				"Dog's Name": quizData.dogInfo.name,
				"Recommended Variant": variantInfo["Recommended Variant"],
				"Other Variety": variantInfo["Other Variety"],
			};

			//add properties value
			Object.keys(propertyList).forEach(function (property) {
				html += `<input name="properties[${property}]" value="${propertyList[property]}" />`;
			});

			propertyElm && (propertyElm.innerHTML = html);
		}
	}

	//filter dietOptions
	filterDietOptions() {
		var info = this.dogInformation;
		var variantsOptions = this.dietOptions.healthy;

		//Check is dog healthy or not
		if (info.isDogHealthy == false) {
			variantsOptions = this.dietOptions.healthIssue;
		}

		//filter diet key
		var diet = [];
		Object.keys(variantsOptions).map(function (key) {
			info.dogInfo.multiSelect.forEach(function (selectOption) {
				if (
					!diet.includes(key) &&
					variantsOptions[key].includes(selectOption)
				) {
					diet.push(key);
				}
			});
		});

		//update diet
		this.udpateDietsVariant(diet);

		this.updateProperties(this.dogInformation);
	}

	//event handlers
	dispatchEventHandler() {
		var _this = this;
		window.addEventListener("lastQuizStep", () => {
			//update diet options
			var localDogInfo = localStorage.getItem("dogInformation");
			if (localDogInfo) {
			}
			this.dogInformation = localDogInfo && JSON.parse(localDogInfo);
			//filter options
			_this.filterDietOptions();
		});

		//click on diet item button
		this._liveClickMethod(
			"#product-container .productVariants .variety-box .dite-opt",
			"click",
			function () {
				_this.removeClass(".active_dietVariant", "active_dietVariant");
				var dietParentEl = this.closest(".variety-box[diet-type]");
				if (dietParentEl) {
					dietParentEl.classList.add("active_dietVariant");
					var dietType = dietParentEl.getAttribute("diet-type");

					//product-diet-active
					var variantInfo = document.querySelector(
						`#product-right-content .product-diet-row[data-type="${dietType}"]`
					);
					if (variantInfo) {
						_this.removeClass(
							".product-diet-active",
							"product-diet-active"
						);
						variantInfo.classList.add("product-diet-active");
					}
				}
			}
		);

		//change update property
		this._liveClickMethod(
			".product-container .product-left-content .hero-section .check-box > input",
			"change",
			function () {
				_this.updateProperties(_this.dogInformation);
			}
		);
	}
}
window.customElements.define("new-quiz-laststep", QuizLastStep);

//Quiz last step
class QuizLastStepClone extends HTMLElement {
	constructor() {
		super();
		//diet options data
		this.dietOptions = {
			healthIssue: {
				wood: ["Sensitive stomach", "Liver support", "Seizures"],
				fire: [
					"Pancreatitis",
					"Cushings",
					"Environmental skin allergies",
					"Anxiety",
				],
				earth: ["Obesity", "Cancer remission"],
				metal: ["Weight gain", "Cancer treatment", "Diabetes"],
				water: [
					"Inflammatory Bowel Disease",
					"Food allergies",
					"Kidney support",
					"Arthritis and hind leg weakness",
				],
			},
			healthy: {
				wood: [
					"Gentle diet for a sensitive stomach",
					"Gentle diet for a puppy",
				],
				fire: ["Anti-inflammatory", "Lean meat"],
				earth: ["Light and low fat diet", "Vegetarian"],
				metal: ["Improve body and skin dryness", "Hearty meal"],
				water: ["Hypoallergenic", "Picky eaters"],
			},
			totalDiet: ["wood", "fire", "earth", "metal", "water"],
			dietData: {
				wood: {
					image: "https://cdn.shopify.com/s/files/1/0550/7543/8658/files/wood-diet.svg",
					halfImage:
						"https://cdn.shopify.com/s/files/1/0550/7543/8658/files/istockphoto-486932107-612x612_1_1.png?v=1738904948",
					icon: "https://cdn.shopify.com/s/files/1/0550/7543/8658/files/wood-icon.svg",
					items: [
						"Chicken",
						"Chicken Eggs",
						"Brown Rice",
						"Chinese Eggplant",
						"Carrots",
						"Broccoli",
					],
					micro_copy:
						"Created for dogs with Picky appetite, Sensitive stomach, Liver support",
					description:
						"The wood diet helps the body to function optimally, resulting in a natural increase in vitality.",
				},
				fire: {
					image: "https://cdn.shopify.com/s/files/1/0550/7543/8658/files/fire-diet.svg",
					halfImage:
						"https://cdn.shopify.com/s/files/1/0550/7543/8658/files/istockphoto-486932107-612x612_1_1.png?v=1738904948",
					icon: "https://cdn.shopify.com/s/files/1/0550/7543/8658/files/fire-icon.svg",
					items: [
						"Turkey",
						"Carrots",
						"Millet",
						"Edamame",
						"Broccoli",
					],
					micro_copy:
						"Created for dogs with Picky appetite, Sensitive stomach, Liver support",
					description:
						"Fire Diet is composed of cooling ingredients for an overall anti-inflammatory effect on the body.",
				},
				earth: {
					image: "https://cdn.shopify.com/s/files/1/0550/7543/8658/files/earth-diet.svg",
					halfImage:
						"https://cdn.shopify.com/s/files/1/0550/7543/8658/files/istockphoto-486932107-612x612_1_1.png?v=1738904948",
					icon: "https://cdn.shopify.com/s/files/1/0550/7543/8658/files/Vector_2_ba4c03af-4742-44cd-8c5e-4aa222823784.png?v=1671020951",
					items: [
						"Egg",
						"Sweet Potato",
						"Green Peas",
						"Tofu",
						"Spinach",
						"Mushroom",
					],
					micro_copy:
						"Created for dogs with Picky appetite, Sensitive stomach, Liver support",
					description:
						"Earth Diet is a light diet that works to release toxins and balance the body.",
				},
				metal: {
					image: "https://cdn.shopify.com/s/files/1/0550/7543/8658/files/metal-diet.svg",
					halfImage:
						"https://cdn.shopify.com/s/files/1/0550/7543/8658/files/istockphoto-486932107-612x612_1_1.png?v=1738904948",
					icon: "https://cdn.shopify.com/s/files/1/0550/7543/8658/files/metal-icon.svg",
					items: [
						"Beef",
						"Kale",
						"Bok Choy",
						"White Potato",
						"Carrots",
					],
					micro_copy:
						"Created for dogs with Picky appetite, Sensitive stomach, Liver support",
					description:
						"Metal Diet is a hydrating and strengthening diet that nourishes and builds the blood in the body.",
				},
				water: {
					image: "https://cdn.shopify.com/s/files/1/0550/7543/8658/files/water-diet.svg",
					halfImage:
						"https://cdn.shopify.com/s/files/1/0550/7543/8658/files/istockphoto-486932107-612x612_1_1.png?v=1738904948",
					icon: "https://cdn.shopify.com/s/files/1/0550/7543/8658/files/Vector_4.png?v=1671020967",
					items: [
						"Pork",
						"Peas",
						"Watercress",
						"Barley",
						"Sweet Potato",
					],
					micro_copy:
						"Created for dogs with Picky appetite, Sensitive stomach, Liver support",
					description:
						"Water Diet ingredients are hydrating, benefitting specifically the stomach and the kidneys.",
				},
				bag: {
					image: "https://cdn.shopify.com/s/files/1/0550/7543/8658/files/bag.png?v=1675187833",
					title: "Keep Fresh Storage Bag",
				},
			},
		};

		//Selected custom diet
		this.customDietSelected = [];

		//get dog and your information
		var localDogInfo = localStorage.getItem("dogInformation");
		this.dogInformation = localDogInfo && JSON.parse(localDogInfo);

		//variant options
		this.variants = this.querySelectorAll(
			".diet-info-col .check-box input"
		);

		//all step qualifying
		this.filterDietOptions();

		//dispatch eventsTarget
		this.dispatchEventHandler();
	}
	/**
	 * pure functions
	 */
	// live click method
	_liveClickMethod(selector, event, callback, context) {
		// helper for enabling IE 8 event bindings
		function addEvent(el, type, handler) {
			if (el.attachEvent) el.attachEvent("on" + type, handler);
			else el.addEventListener(type, handler);
		}
		// matches polyfill
		this &&
			this.Element &&
			(function (ElementPrototype) {
				ElementPrototype.matches =
					ElementPrototype.matches ||
					ElementPrototype.matchesSelector ||
					ElementPrototype.webkitMatchesSelector ||
					ElementPrototype.msMatchesSelector ||
					function (selector) {
						var node = this,
							nodes = (
								node.parentNode || node.document
							).querySelectorAll(selector),
							i = -1;
						while (nodes[++i] && nodes[i] != node);
						return !!nodes[i];
					};
			})(Element.prototype);
		// live binding helper using matchesSelector
		function _liveClickMethod(selector, event, callback, context) {
			addEvent(context || document, event, function (e) {
				var found,
					el = e.target || e.srcElement;
				while (
					el &&
					el.matches &&
					el !== context &&
					!(found = el.matches(selector))
				)
					el = el.parentElement;
				if (found) callback.call(el, e);
			});
		}
		_liveClickMethod(selector, event, callback, context);
	}
	//remove class
	removeClass(selector, cls) {
		var el = document.querySelectorAll(selector);
		if (el.length > 0) {
			el.forEach(function (item) {
				item.classList.contains(cls) && item.classList.remove(cls);
			});
		}
	}
	//add Class
	addClass(selector, cls) {
		var el = document.querySelector(selector);
		if (el) {
			el.classList.add(cls);
		}
	}

	/**
	 *
	 * @param {String} diet
	 * @param {String} type
	 * @param {Number} index
	 * @param {Object} dietOptionsDesc
	 * @returns
	 */
	buildDietVariant(diet, type, index, dietOptionsDesc) {
		var checkedDiet = "";
		var activeCls = "";
		var html = "";
		//if type description
		if (type == "recommend") {
			checkedDiet = "checked";
		}

		//active diet variant
		if (index == 0) {
			activeCls = "active_dietVariant";

			//active diet detail
			var activeDiet = document.querySelector(
				"#product-right-content .product-diet-row.product-diet-active"
			);
			var newActiveDiet = document.querySelector(
				`#product-right-content .product-diet-row[data-type='${diet}']`
			);
			activeDiet && activeDiet.classList.remove("product-diet-active");
			newActiveDiet && newActiveDiet.classList.add("product-diet-active");
		}

		//diet data change
		var data = this.dietOptions.dietData[`${diet}`];
		var dietList = "";

		//get description
		var dietDescription = "";
		if (dietOptionsDesc) {
			var description = dietOptionsDesc[diet];
			if (description && description.length > 0) {
				dietDescription = "Helps with ";
			}
			description &&
				description.forEach(function (text, i) {
					if (i == 0) {
						dietDescription +=
							"<span class='dietdes-txt'>" + text + "</span>";
					} else {
						dietDescription +=
							", <span class='dietdes-txt'>" + text + "</span>";
					}
				});
		}

		if (data) {
			data.items &&
				data.items.forEach(function (item) {
					dietList += `<li>${item}<span class="diet_listMobile">/</span></li>`;
				});
			if (diet == "bag") {
				html = `
          <div class="diet-box-1 variety-box" diet-type="${diet}">
          <div id="tab-fire-recommendation-quiz" class="recommendation" >Recommended</div>
              <div class="diet-info-box">
                <div class="diet-info-wrapper">
                <div class="diet-info-row">
                  <div class="diet-info-col">
                    <div class="diet-img 1">
                      <img src="${data.image}" alt="${diet}">
                      </div>
                  </div>
                  <div class="diet-info-col diet-info-col-right">
                    <div class="diet-name-log">
                      <h2>Keep Fresh Storage Bag</h2>
                    </div>
                  </div>
                </div>
                </div>
                <div class="diet-info-row diet-info-row-bottom">
                  <div class="diet-info-col">
                    <label class="check-box" for="${diet}-diet">
                      <input type="checkbox" id="${diet}-diet" name="${diet}" ${checkedDiet} isrecommend="${type}">
                      <span class="plan-needtoAdd">Add to Meal Plan</span>
                      <span class="plan-added">Added</span>
                    </label>
                  </div>
                  <div class="diet-info-col"></div>
                </div>
              </div>
          </div>`;
			} else {
				html = `
        <div class="diet-box-1 variety-box ${activeCls}" diet-type="${diet}">
        <div id="tab-fire-recommendation-quiz" class="recommendation" >Recommended</div>
            <div class="diet-info-box">
              <div class="diet-info-wrapper">
               <div class="diet-info-row">
                <div class="diet-info-col">
                   <div class="diet-img newHalfOrder">
                     <div class="line" style=""></div>
                      <img class="halfImage" src="${data.halfImage}" alt="${diet}">
                      <img class="mainImage" src="${data.image}" alt="${diet}">
                    </div>
                </div>
                <div class="diet-info-col diet-info-col-right">
                   <div class="diet-name-log">
                     <div class="logo"><img src="${data.icon}" alt=""></div>
                     <h2>${diet} Diet</h2>
                   </div>
                   <ul class="diet">${dietList}</ul>
                </div>
              </div>
              <p class="diet-content">${data.description}</p>
              <p class="diet-content">${dietDescription}</p>
              </div>
              <div class="diet-info-row diet-info-row-bottom">
                <div class="diet-info-col">
                  <label class="check-box" for="${diet}-diet">
                    <input type="checkbox" id="${diet}-diet" name="${diet}" ${checkedDiet} isrecommend="${type}">
                    <span class="plan-needtoAdd">Add to Meal Plan</span>
                    <span class="plan-added">Added</span>
                  </label>
                </div>
                <div class="diet-info-col">
                  <div class="diet-detail-button desk" modal-id="${diet}"><span class="plan-needtoAdd-2">Learn more about meal</span><span class="plan-added-2">Learn more about the ${diet} diet</span><img src="https://cdn.shopify.com/s/files/1/0550/7543/8658/files/Vector_10.png?v=1674021566"
                  alt="Vector-10"/>
                   </div>
                   <div class="diet-detail-button mobile" modal-id="${diet}">Learn more<img src="https://cdn.shopify.com/s/files/1/0550/7543/8658/files/Vector_10.png?v=1674021566"
                  alt="Vector-10"/></div>
                </div>
              </div>
            </div>
        </div>`;
			}
		} else {
			return "";
		}

		return html;
	}
	//recommended diet
	getVariantSection(diets, type, dietOptions) {
		var html = "",
			_this = this;
		if (type == "recommend") {
			diets.forEach(function (diet, i) {
				html += _this.buildDietVariant(
					diet,
					"recommend",
					i,
					dietOptions
				);
			});
		} else {
			diets.forEach(function (diet) {
				html += _this.buildDietVariant(diet, "", "", dietOptions);
			});
		}

		return html;
	}

	/**
	 * build custom diet nav
	 */
	buildCutomMealNav() {
		var html = "",
			_this = this;
		var customNavBuild = [];
		this.customDietSelected.forEach(function (diets) {
			var data = _this.dietOptions.dietData[`${diets.diet}`];
			if (!customNavBuild.includes(diets.diet)) {
				customNavBuild.push(diets.diet);
				html += `
        <li class="chidog-dite-img ${
			diets.isSelected == true ? "active-diet-opt" : ""
		}" diet-opt="${diets.diet}" >
          <div class="diet-nav-box">
            <img src="${data.image}">
            <span>${diets.diet}</span>
          </div>
          <div class="diet-opt-selectIcon">
            <img class="diet-add-icon" src="https://cdn.shopify.com/s/files/1/0550/7543/8658/files/plus.png?v=1674816491"/>
            <img class="diet-remove-icon" src="https://cdn.shopify.com/s/files/1/0550/7543/8658/files/cross.png?v=1674816519"/>
          </div>
        </li>`;
			}
		});
		return html;
	}

	//recommended diet options
	recommendedDietOptions(diets, dietOptions) {
		var special_die = diets.join(", ").replace(/, ([^,]*)$/, " and $1");
		$("#special_diet_txt").html(special_die);
		if (diets.length > 0) {
			var html = this.getVariantSection(diets, "recommend", dietOptions);
			this.recommendEl.innerHTML = html;
		} else {
			diets = ["wood"];
			var html = this.getVariantSection(diets, "recommend", dietOptions);
			this.recommendEl.innerHTML = html;

			//push diet
			this.customDietSelected.push({
				diet: "wood",
				isSelected: true,
			});
		}
	}

	//Other variant options
	otherVariantsOptions(otherVariants, dietOptions) {
		var html = "",
			_this = this;
		if (otherVariants.length > 0) {
			html = this.getVariantSection(otherVariants, "", dietOptions);
			this.removeClass(
				".last-step-container .last-step-bottom-section",
				"quiz-step-hide"
			);

			//push other diet in list
			otherVariants.forEach(function (key) {
				if (key != "bag") {
					_this.customDietSelected.push({
						diet: key,
						isSelected: false,
					});
				}
			});
		} else {
			html = "";
			this.addClass(
				".last-step-container .last-step-bottom-section",
				"quiz-step-hide"
			);
		}
		return html;
	}

	//update diet
	udpateDietsVariant(diets, dietOptions) {
		var otherVariants = this.dietOptions.totalDiet.filter((i) => {
			//if diet includes i(diet name) or if diet length 0 and i is not contains "wood"
			return (
				(diets.length == 0 && i != "wood") ||
				(!diets.includes(i) && diets.length > 0)
			);
		});

		//recommended diet
		this.recommendEl = this.querySelector(".custom-selected-diet");
		if (this.recommendEl) {
			this.recommendedDietOptions(diets, dietOptions);
		}

		//other variant section
		this.otherDiet = this.querySelector(".other-custom-diets");
		if (this.otherDiet) {
			// otherVariants.push("bag");
			var html = this.otherVariantsOptions(otherVariants, dietOptions);
			this.otherDiet.innerHTML = html;
		}

		//selected variant Options
		var customDietSelection = this.querySelector(".custom-diet-options");
		if (this.customDietSelected.length > 0 && customDietSelection) {
			var html = this.buildCutomMealNav();
			customDietSelection.innerHTML = html;
		}

		//variant select options
		this.variants = this.querySelectorAll(
			".diet-info-col .check-box input"
		);
	}

	/**
	 *
	 * @returns { "Custom Plan": [] }
	 */
	//variant selection
	variantSelectionBox() {
		// var selectedVariant = { "Recommended Variant": [], "Other Variety": [] };
		var selectedVariant = { "Custom Plan": [] };
		var arry = [];
		if (this.variants.length > 0) {
			this.variants.forEach(function (variant) {
				if (variant.checked && variant.name != "bag") {
					var special_die = variant.name;
					arry.push(special_die);
					selectedVariant["Custom Plan"].push(variant.name);
				}

				// if (variant.getAttribute("isrecommend") == "recommend") {
				//   // selectedVariant["Recommended Variant"].push(variant.name);
				//   selectedVariant["Custom Plan"].push(variant.name);
				// } else {
				//   // selectedVariant["Custom Plan"].push(variant.name);
				// }
			});
			$("#special_diet_txt").html(
				arry.join(", ").replace(/, ([^,]*)$/, " and $1")
			);
		}

		return selectedVariant;
	}

	//update properties
	updateProperties(quizData) {
		if (quizData.yourInfo.yourName) {
			var propertyElm = document.querySelector(".product_properties");
			var html = "";

			var variantInfo = this.variantSelectionBox();

			//property
			var propertyList = {
				"Dog's Name": quizData.dogInfo.name,
				"Custom Plan": variantInfo["Custom Plan"],
				// "Other Variety": variantInfo["Custom Plan"],
			};

			//add properties value
			Object.keys(propertyList).forEach(function (property) {
				html += `<input name="properties[${property}]" value="${propertyList[property]}" />`;
			});

			propertyElm && (propertyElm.innerHTML = html);
		}
	}

	/**
	 * Filter diet options based on last quiz step selection
	 */
	filterDietOptions() {
		var info = this.dogInformation;
		var variantsOptions = this.dietOptions.healthy;
		this.customDietSelected = [];

		var _this = this;

		//Check is dog healthy or not
		if (info.isDogHealthy == false) {
			variantsOptions = this.dietOptions.healthIssue;
		}

		//filter diet key
		var diet = [];
		var dietOptions = {};
		Object.keys(variantsOptions).map(function (key) {
			info.dogInfo.multiSelect.forEach(function (selectOption) {
				if (
					!diet.includes(key) &&
					variantsOptions[key].includes(selectOption)
				) {
					diet.push(key);

					//selected diet options
					_this.customDietSelected.push({
						diet: key,
						isSelected: true,
					});
				}

				//for other diet
				if (variantsOptions[key].includes(selectOption)) {
					if (dietOptions[key] == undefined) {
						dietOptions[key] = [];
					}
					dietOptions[key].push(selectOption);
				}
			});
		});

		//update diet
		this.udpateDietsVariant(diet, dietOptions);

		//update line property value
		this.updateProperties(this.dogInformation);
	}

	/**
	 * update diet options
	 */
	updateCustomDietVariants(varientBox, inputElm) {
		//options
		var customElm = this.querySelector(
				".last-step-container .custom-selected-diet"
			),
			otherElm = this.querySelector(
				".last-step-container .other-custom-diets"
			);

		//if variant box not available then return
		if (!varientBox) return;

		//if option checked
		if (inputElm.checked) {
			customElm && customElm.appendChild(varientBox);
		} else {
			otherElm && otherElm.appendChild(varientBox);
		}

		//check and hide section
		var customElmBox = this.querySelectorAll(
				".custom-selected-diet .variety-box"
			),
			otherElmBox = this.querySelectorAll(
				".other-custom-diets .variety-box"
			);

		//custom box
		if (customElmBox.length > 0) {
			if (
				customElmBox.length == 1 &&
				document.querySelector(
					'.last-step-container .last-step-top-section [diet-type="bag"]'
				)
			) {
				this.addClass(
					".last-step-container .last-step-top-section",
					"quiz-step-hide"
				);
			} else {
				this.removeClass(
					".last-step-container .last-step-top-section",
					"quiz-step-hide"
				);
			}
		} else {
			this.addClass(
				".last-step-container .last-step-top-section",
				"quiz-step-hide"
			);
		}

		//other box
		if (otherElmBox.length > 0) {
			this.removeClass(
				".last-step-container .last-step-bottom-section",
				"quiz-step-hide"
			);
		} else {
			this.addClass(
				".last-step-container .last-step-bottom-section",
				"quiz-step-hide"
			);
		}

		//variant options
		this.variants = this.querySelectorAll(
			".diet-info-col .check-box input"
		);
		//update line property value
		this.updateProperties(this.dogInformation);
	}

	//event handlers
	dispatchEventHandler() {
		var _this = this;
		//last step fired
		window.addEventListener("lastQuizStep", () => {
			//update diet options
			var localDogInfo = localStorage.getItem("dogInformation");
			if (localDogInfo) {
			}
			this.dogInformation = localDogInfo && JSON.parse(localDogInfo);
			//filter options
			_this.filterDietOptions();
		});

		//click on diet details show button
		this._liveClickMethod(".diet-detail-button", "click", function () {
			$(".bm004-rightTabRows").css("display", "block");
			var modalId = this.getAttribute("modal-id"),
				modalContentEl = document.querySelector(
					`.bm-quiz-model #${modalId}-model`
				),
				modalBox = document.querySelector("new-quiz-details-modal");

			if (modalId && modalContentEl) {
				_this.removeClass(
					".bm-quiz-model .model-content",
					"active-modal-content"
				);
				modalContentEl.classList.add("active-modal-content");
				modalBox.classList.add("active-quiz-modal");
			}
		});

		//click on diet add and remove button
		this._liveClickMethod(
			".custom-diet-options .chidog-dite-img",
			"click",
			function () {
				var optType = this.getAttribute("diet-opt");
				var dietOptInput = _this.querySelector(
					`.variety-box[diet-type="${optType}"] .diet-info-col input`
				);

				//dispatch change events
				if (!dietOptInput) return;
				dietOptInput.click();
			}
		);

		//on diet variant change
		this._liveClickMethod(
			".variety-box .diet-info-col input",
			"change",
			function () {
				var varientBox = this.closest(".variety-box"),
					optid = varientBox && varientBox.getAttribute("diet-type"),
					optNavBox = _this.querySelector(
						`.custom-diet-options .chidog-dite-img[diet-opt="${optid}"]`
					);

				//toggle active class
				optNavBox && optNavBox.classList.toggle("active-diet-opt");

				//update variant diet options
				_this.updateCustomDietVariants(varientBox, this);
			}
		);
	}
}
window.customElements.define("new-quiz-laststep-copy", QuizLastStepClone);

//Quiz last step
class QuizModal extends HTMLElement {
	constructor() {
		super();

		//dispatch eventsTarget
		this.dispatchEventHandler();
	}
	/**
	 * pure functions
	 */
	// live click method
	_liveClickMethod(selector, event, callback, context) {
		// helper for enabling IE 8 event bindings
		function addEvent(el, type, handler) {
			if (el.attachEvent) el.attachEvent("on" + type, handler);
			else el.addEventListener(type, handler);
		}
		// matches polyfill
		this &&
			this.Element &&
			(function (ElementPrototype) {
				ElementPrototype.matches =
					ElementPrototype.matches ||
					ElementPrototype.matchesSelector ||
					ElementPrototype.webkitMatchesSelector ||
					ElementPrototype.msMatchesSelector ||
					function (selector) {
						var node = this,
							nodes = (
								node.parentNode || node.document
							).querySelectorAll(selector),
							i = -1;
						while (nodes[++i] && nodes[i] != node);
						return !!nodes[i];
					};
			})(Element.prototype);
		// live binding helper using matchesSelector
		function _liveClickMethod(selector, event, callback, context) {
			addEvent(context || document, event, function (e) {
				var found,
					el = e.target || e.srcElement;
				while (
					el &&
					el.matches &&
					el !== context &&
					!(found = el.matches(selector))
				)
					el = el.parentElement;
				if (found) callback.call(el, e);
			});
		}
		_liveClickMethod(selector, event, callback, context);
	}
	//remove class
	removeClass(selector, cls) {
		var el = document.querySelectorAll(selector);
		if (el.length > 0) {
			el.forEach(function (item) {
				item.classList.contains(cls) && item.classList.remove(cls);
			});
		}
	}
	//add Class
	addClass(selector, cls) {
		var el = document.querySelector(selector);
		if (el) {
			el.classList.add(cls);
		}
	}

	//event handlers
	dispatchEventHandler() {
		var _this = this;
		this._liveClickMethod(
			"new-quiz-details-modal .bm-quiz-overlay, new-quiz-details-modal .crossmodel",
			"click",
			function (e) {
				_this.classList.contains("active-quiz-modal") &&
					_this.classList.remove("active-quiz-modal");
			}
		);
	}
}
window.customElements.define("new-quiz-details-modal", QuizModal);

//product variant reset
class VariantSelectsBox extends HTMLElement {
	constructor() {
		super();
		this.closestvariantSelectsOpt =
			document.querySelector("variant-selects");
		this.selectWeekOption = this.querySelector(
			'.select [name="options[Delivery Time]"], .select [name*="Delivery"]'
		);
		this.selectWeekOptionButton = document.querySelector(
			".delivery-button-option"
		);
		this.initLoad();
		this.addEventListener("change", this.onVariantChange);
		this.selectWeekOptionButton.addEventListener(
			"click",
			this.changeSelected.bind(this)
		);
	}

	initLoad() {
		this.updateOptions();
		this.updateMasterId();
		//inser week option
		this.insertWeekOption();
	}

	onVariantChange() {
		console.log("quiz variant change");
		this.updateOptions();
		this.updateMasterId();

		var _this = this;

		//update week option
		if (
			event.target &&
			event.target.name &&
			event.target.name.includes("eight")
		) {
			this.insertWeekOption();
		}

		if (this.currentVariant) {
			var selectOptions = document.querySelectorAll(
				"variant-selects .product-form__input select"
			);
			if (selectOptions.length > 0) {
				selectOptions.forEach(function (select, i) {
					if (i == 0) {
						select.value = _this.currentVariant.option1;
					} else if (i == 1) {
						select.value = _this.currentVariant.option2;
					}
					select.dispatchEvent(
						new Event("change", { bubbles: true })
					);
				});
			}
		}

		this.updateVariantInput();

		document.dispatchEvent(
			new CustomEvent("afterVariantChange", {
				bubbles: true,
				detail: { event },
			})
		);
	}

	/**
	 * insert week options
	 */
	insertWeekOption() {
		this.totalVariants = this.getVariantData().filter((variant) => {
			return variant.option1 == this.options[0];
		});

		if (this.selectWeekOption) {
			var { drop_down_html, button_html } = this.generateWeekOption();
			if (drop_down_html) {
				this.selectWeekOption.innerHTML = drop_down_html;
				this.selectWeekOptionButton.innerHTML = button_html;
			}
		}
	}

	getWeekNumbers(variant) {
		return parseInt(variant.option2.split("Week")[0]);
	}

	//generate and insert week option
	generateWeekOption() {
		var drop_down_html = "",
			button_html = "",
			_this = this;

		const productForms = document.querySelectorAll(`form.quiz-form`);
		var _this = this;
		var selcetedVariantId = null;
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]');
			selcetedVariantId = input.value;
			input.dispatchEvent(new Event("change", { bubbles: true }));
		});

		var currentVariant = this.getVariantData().find((variant) => {
			return variant["id"] == selcetedVariantId;
		});

		if (this.totalVariants.length > 0) {
			this.totalVariants.forEach(function (variant, i) {
				// change to weeks/week text based on number of week
				var week = "week";
				var weekText = "";
				const weekNumber = _this.getWeekNumbers(variant);
				if (weekNumber > 1) {
					week = "weeks";
					weekText = variant.option2.split("Weeks")[1];
				} else {
					week = "week";
					weekText = variant.option2
						.split("Week")[1]
						.replace("s ", "");
				}

				const selectedWeekNumber = _this.getWeekNumbers(currentVariant);
				let selectedOption = "";

				if (selectedWeekNumber == weekNumber) {
					selectedOption = "selected-option";
				}

				selectedOption = "selected-option";

				if (i == 0) {
					drop_down_html +=
						'<option value="' +
						variant.option2 +
						'" selected="selected">' +
						variant.option2 +
						"</option>";
					button_html += `<div class="delivery-button ${selectedOption}" data-weeks="${weekNumber}" data-delivery-value="${
						variant.option2
					}">${
						weekNumber == 4 ? '<p class="off_text"></p>' : ""
					}<span>${weekNumber} ${week}</span>${weekText}</div>`;
				} else {
					drop_down_html +=
						'<option value="' +
						variant.option2 +
						'">' +
						variant.option2 +
						"</option>";
					button_html += `<div class="delivery-button" data-weeks="${weekNumber}" data-delivery-value="${
						variant.option2
					}">${
						weekNumber == 4
							? '<p class="off_text">Lower cost per day</p>'
							: ""
					}<span>${weekNumber} ${week}</span>${weekText}</div>`;
				}
			});
		}

		return { drop_down_html, button_html };
	}

	removeClass(closestVariantSelector) {
		closestVariantSelector
			.querySelectorAll(".delivery-button")
			.forEach((el, index) => {
				el.className = "delivery-button";
			});
	}

	changeSelected(event) {
		console.log("event");
		console.log(event.target.dataset);
		$(".delivery-button:visible span").removeClass("selected-option");
		var target = event.target;
		if (!target.dataset.deliveryValue) {
			target = target.closest(".delivery-button");
		}
		const targetClassList = target.className;
		if (targetClassList.indexOf("selected-option") > -1) {
			return false;
		}

		const closestVariantSelector = event.target.closest("variant-selects");
		this.closestvariantSelectsOpt = event.target.closest("variant-selects");
		this.removeClass(closestVariantSelector);
		event.target.classList.add("selected-option");

		if ($(".delivery-button:visible span").hasClass("selected-option")) {
			$(".delivery-button:visible").removeClass("selected-option");
			$(".delivery-button:visible .selected-option")
				.parents(".delivery-button")
				.addClass("selected-option");
		}
		var $select = closestVariantSelector.querySelector(
			'[name="options[Delivery Options]"]'
		);
		if (!$select) {
			$select = closestVariantSelector.querySelector(
				'[name="options[Delivery Time]"]'
			);
		}
		$select.value = target.dataset.deliveryValue;
		console.log($select);
		$select.dispatchEvent(new Event("change", { bubbles: true }));
		// $select.dispatchEvent(new Event("change", { bubbles: false }));
		this.updateVariantInput();
		// this.onVariantChange($select);
		// event.stopImmediatePropagation();

		// ✅ 1. Trigger change on current <variant-selects> element
		const variantSelects = document.querySelector("variant-selects-box");

		if (variantSelects) {
			// Find the actual <select> for Delivery Time inside variant-selects
			const deliverySelect = variantSelects.querySelector(
				'[name="options[Delivery Time]"]'
			);

			if (deliverySelect) {
				// Set its value to match what was just selected in the quiz box
				deliverySelect.value = target.dataset.deliveryValue;

				// Trigger native change so Shopify updates variant + price + form
				deliverySelect.dispatchEvent(
					new Event("change", { bubbles: true, composed: true })
				);
			}
		}
	}

	updateOptions() {
		// this.options = Array.from(
		// 	this.querySelectorAll('select[name*="eight"]'),
		// 	(select) => select.value
		// );

		this.options = Array.from(
			this.querySelectorAll('select[name^="options["]'),
			(select) => select.value
		);
		// console.log(ptions);
	}

	updateMasterId() {
		this.currentVariant = this.getVariantData().find((variant) => {
			// return variant["option1"] == this.options[0];
			return (
				variant.option1 === this.options[0] &&
				variant.option2 === this.options[1]
			);
		});

		this.getPerDayPrice(this.currentVariant);
		// this.updateVariantInput();
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(`form.quiz-form`);
		var _this = this;
		var selcetedVariantId = null;
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]');
			input.value = _this.currentVariant.id;

			selcetedVariantId = input.value;
			input.dispatchEvent(new Event("change", { bubbles: true }));
		});

		this.currentVariant = this.getVariantData().find((variant) => {
			return variant["id"] == selcetedVariantId;
		});

		this.getPerDayPrice(_this.currentVariant);
	}

	getPerDayPrice(variant) {
		const weekNumber = this.getWeekNumbers(variant);
		const perWeekPrice = variant.price / 100 / weekNumber;
		const actualPrice = variant.price / 100;
		const priceHtml = this.generatePriceHtml(perWeekPrice, actualPrice);
		$(".product-form .inline-price span").html(priceHtml);
		$(`.shippedWeeksCount .weeks`).text(`${weekNumber} weeks`);
	}

	generatePriceHtml(perWeekPrice, actualPrice) {
		const discountPercentage = 20;
		const discountedPrice = perWeekPrice * (1 - discountPercentage / 100);
		return `
        <div class="priceSummery" data-actual-price=${actualPrice} data-applicable-price="${discountedPrice}" style="font-family: 'Satoshi'; display: inline-flex; align-items: baseline; gap: 5px;">
            <span style="font-weight: 700;text-decoration: line-through; color: #999;">$${perWeekPrice.toFixed(
				2
			)}</span>
            <span style="font-weight: bold; font-size: 24px;">$${discountedPrice.toFixed(
				2
			)}<span style="font-size: 16px;">/week</span></span>
            <span style="font-size: 18px;margin-left: 10px;">(${discountPercentage}% first box discount)</span>
        </div>
    `;
	}

	getVariantData() {
		this.variantData =
			this.variantData ||
			JSON.parse(
				this.querySelector('[type="application/json"]').textContent
			);
		console.log(this.variantData);
		return this.variantData;
	}
}
customElements.define("variant-selects-box", VariantSelectsBox);
